<template>
  <div class="news">
    <div class="row">
      <div class=" mt-3 col-lg-12">
        <InfoCard :info="tutorialInfo"></InfoCard>
      </div>
    </div>
    <div class="col-12 text-center" v-if="fetchingNewsItems">
      <div class="alert alert-primary" role="alert">
        Nieuwsberichten ophalen.
      </div>
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Laden...</span>
        </div>
      </div>
    </div>
    <div class="col-12 text-center" v-else-if="newsItems.length === 0">
      <h3>Geen nieuwsberichten gevonden.</h3>
    </div>
    <div class="row" v-else>
      <div class="col-lg-8">
        <div @click="loadNewsItem(latestNewsItems[0].id)" class="article article-lg" v-if="latestNewsItems.length >= 1">
          <div class="image">
            <img :src="latestNewsItems[0].bannerImage.url" :alt="'Afbeelding voor ' + latestNewsItems[0].title"
                 loading="lazy" v-if="latestNewsItems[0].bannerImage">
            <div class="news-image-placeholder" v-else>
              <PlaceholderIcon/>
            </div>
          </div>
          <div class="info-wrapper">
            <div class="info">
              <p class="dateline">{{
                formatDayDateMonthYear(latestNewsItems[0].publicationStatus.lastPublicationDate)
                }}</p>
              <p class="title">{{ latestNewsItems[0].title }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div :class="latestNewsItems.length !== 2? 'col-lg-6': 'col-lg-12'">
            <div @click="loadNewsItem(latestNewsItems[1].id)" class="article"
                 :class="latestNewsItems.length !== 2? 'article-sm': 'article-lg'" v-if="latestNewsItems.length >= 2">
              <div class="image">
                <img :src="latestNewsItems[1].bannerImage.url" :alt="'Afbeelding voor ' + latestNewsItems[1].title"
                     loading="lazy" v-if="latestNewsItems[1].bannerImage">
                <div class="news-image-placeholder" v-else>
                  <PlaceholderIcon/>
                </div>
              </div>
              <div class="info-wrapper">
                <div class="info">
                  <p class="dateline">
                    {{ formatDayDateMonthYear(latestNewsItems[1].publicationStatus.lastPublicationDate) }}</p>
                  <p class="title">{{ latestNewsItems[1].title }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div @click="loadNewsItem(latestNewsItems[2].id)" class="article article-sm"
                 v-if="latestNewsItems.length >= 3">
              <div class="image">
                <img :src="latestNewsItems[2].bannerImage.url" :alt="'Afbeelding voor ' + latestNewsItems[2].title"
                     loading="lazy" v-if="latestNewsItems[2].bannerImage">
                <div class="news-image-placeholder" v-else>
                  <PlaceholderIcon/>
                </div>
              </div>
              <div class="info-wrapper">
                <div class="info">
                  <p class="dateline">
                    {{ formatDayDateMonthYear(latestNewsItems[2].publicationStatus.lastPublicationDate) }}</p>
                  <p class="title">{{ latestNewsItems[2].title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="newsItems.length > 0">
        <div class="old-articles-card">
          <div class="header">
            <h2 class="title">Vorige berichten</h2>
          </div>
          <ArticleList :news-items="newsItems" :total-news-items="info.totalElements"
                       :news-items-per-page="itemsPerPage"></ArticleList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleList from "@/components/News/ArticleList";
import DateFormatter from "@/mixins/DateFormatter";
import InfoCard from "@/components/Common/InfoCard";
import log from "@/utils/logger";
import { NewsApi } from "sandpiper_api";

import PlaceholderIcon from "@/assets/image/news/icon-news_placeholder.svg?inline";

export default {
  name: "News",
  components: { ArticleList, InfoCard, PlaceholderIcon },
  props: {},
  mixins: [ DateFormatter ],
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      tutorialInfo: {
        id: "tutorial_news",
        title: "Nieuwsberichten",
        body: "Sommige nieuwsberichten bevatten nieuwe opdrachten die gekoppeld zijn aan het onderwerp van het nieuwsbericht."
      },
      fetchingNewsItems: false,
      newsItems: [],
      latestNewsItems: [],
      topNewsItemsCount: 3,
      info: {},
      page: 1,
      itemsPerPage: 6
    }
  },
  computed: {
    latestNewsItemIds()
    {
      return this.latestNewsItems.map(newsItem => newsItem.id);
    }
  },
  methods: {
    loadNewsItem(id)
    {
      this.$router.push({
        name: 'article-detailed', params: {
          id: id
        }
      });
    },
    fetchQueryParams()
    {
      this.page = parseInt(this.$route.query.page) || 1;
    },
    async initNewsItems()
    {
      await this.fetchNewsItems();

      if (this.page !== 1 || this.newsItems.length < this.topNewsItemsCount)
      {
        await this.fetchLatestNewsItems();
      }
      else
      {
        this.latestNewsItems = this.newsItems.slice(0, this.topNewsItemsCount);
      }
    },
    async fetchLatestNewsItems()
    {
      try
      {
        this.fetchingNewsItems = true;

        // Clear out the old quests
        this.latestNewsItems = [];

        // Fetch the new quests
        const response = await this.doApiRequest(() => new NewsApi().getPublishedNewsItems({
          count: this.topNewsItemsCount,
          page: 0
        }));

        this.latestNewsItems = response.newsItems;
      }
      catch (e)
      {
        // TODO - handle error
      }
      finally
      {
        this.fetchingNewsItems = false;
      }
    },
    async fetchNewsItems()
    {
      try
      {
        this.fetchingNewsItems = true;

        this.newsItems = [];

        // Fetch the new quests
        const response = await this.doApiRequest(() => new NewsApi().getPublishedNewsItems({
          count: this.itemsPerPage,
          page: this.page - 1
        }));

        this.newsItems = response.newsItems;
        this.info = {
          currentPage: response.currentPage,
          numberOfElements: response.numberOfElements,
          totalPages: response.totalPages,
          totalElements: response.totalElements
        };
      }
      catch (e)
      {
        // TODO - handle error
      }
      finally
      {
        this.fetchingNewsItems = false;
      }
    }
  },
  watch: {
    $route(to, from)
    {
      // We're only watching for param changes on the same page, ignore if we're going to a different page/component
      if (from.name === to.name)
      {
        log.debug("Route watch trigger:\nFrom: %o\nTo: %o", from, to);
        this.fetchQueryParams();
        this.fetchNewsItems();
      }
    }
  },
  created()
  {
    this.fetchQueryParams();
    this.initNewsItems();
  }
}
</script>

<style lang="scss" scoped>
.news
{
  max-width: 1259px;
  margin: 0 auto;
  margin-bottom: 4rem;
}

.article, .old-articles-card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-top: 25px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.old-articles-card
{
  padding: 25px;
}

.article
{
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;

  .image
  {
    height: 410px;
    display: flex;

    img
    {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px 5px 0px 0px;

    }
  }

  .info
  {
    padding: 18px 25px;
    flex: 2 2;
    min-height: 112px;

    .dateline
    {
      font-size: $body-text-size;
      font-style: italic;
      color: $font-grey;
    }

    .title
    {
      font-size: $title-size;
      font-weight: bold;
    }

  }

  @media screen and (max-width: $large)
  {
    align-items: stretch;

    .info-wrapper
    {
      margin: 1rem;
      position: absolute;
      top: 55%;
      left: 0;
      right: 0;
    }

    .info
    {

      background-color: white;
      border-radius: 5px;


      .title
      {
        font-size: $body-text-size;
      }
    }

  }
}

.article-lg
{
  .image
  {
    height: 410px;
  }

  .info
  {
    min-height: 112px;
  }
}

.article-sm
{

  @media screen and (min-width: $large)
  {
    .image
    {
      height: 221px;
    }
    .info
    {
      min-height: 93px;

      .title
      {
        font-size: $body-text-size;
      }
    }
  }

}

@media screen and (max-width: $medium)
{
  .news
  {
    background-color: white;
  }

  .old-articles-card
  {
    background-color: $soft-highlight;
    box-shadow: none;
  }
}
</style>